import { InjectionToken } from '@angular/core';
import { Observable } from 'rxjs';
import {
  CasesQueryParams,
  PaginatedCasesResult,
  VersionHistoryEntry,
  TraceabilityMetrics,
  TraceabilityMetricsFilterParams
} from '@model/traceability/traceability.model';

export interface ITraceabilityQueryPort {
  getSamples(params?: CasesQueryParams): Observable<PaginatedCasesResult>;


  getVersionHistory(identifier: string): Observable<VersionHistoryEntry[]>;


  getMetrics(params?: TraceabilityMetricsFilterParams): Observable<TraceabilityMetrics>;


  getMetricsStream(
    params?: TraceabilityMetricsFilterParams,
    intervalMs?: number
  ): Observable<TraceabilityMetrics>;


  exportSamplesToCSV(params?: CasesQueryParams): Observable<Blob>;
}

export const TRACEABILITY_QUERY_PORT =
  new InjectionToken<ITraceabilityQueryPort>('ITraceabilityQueryPort');
